import styled from 'styled-components';

export const UploadWrapper = styled.div<{ disabled?: boolean }>`
    pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`;

export const FooterWrapper = styled.div`
    padding-bottom: 5.75rem;
`;